import { Button, Col, Modal, Row, Spinner2, Text } from 'components';
import { theme } from 'lib';

const IrreversableModal = ({
  heading,
  topText = '',
  text = 'This action is irreversible.',
  visible,
  waiting = false,
  noOutsideClick,
  closeModal,
  onConfirm,
  confirmNoClose,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onCancel
}) => {
  async function confirm(e) {
    onConfirm();

    if (confirmNoClose || waiting) {
      return;
    }

    closeModal();
  }

  return (
    <Modal
      visible={visible}
      closeModal={closeModal}
      noOutsideClick={noOutsideClick}
      waiting={waiting}
    >
      <Col pad="34px 24px" center className="modal-popup">
        <Text h3 center>
          {heading}
        </Text>
        {waiting && <Spinner2 />}
        {topText && (
          <Text center marg="16px 0 0">
            {topText}
          </Text>
        )}
        {topText && (
          <Text center marg="8px 0 0">
            {text}
          </Text>
        )}
        {!topText && (
          <Text center marg="24px 0 0">
            {text}
          </Text>
        )}
        {!waiting && (
          <Row marg="24px 0 0">
            <Button
              text={cancelText}
              onClick={(!waiting && onCancel) || (!waiting && closeModal)}
              marg="0 24px 0 0"
              disabled={waiting}
            />
            <Button
              className="confirm-action"
              text={confirmText}
              bg={theme.SECONDARY}
              action="removeUpdate"
              onClick={confirm}
              disabled={waiting}
            />
          </Row>
        )}
      </Col>
    </Modal>
  );
};

export default IrreversableModal;
